<template>
  <div>
    <application-menu :app="app" :flow="flow"></application-menu>
    Hello {{ app.name }} with {{ flow.name }} ({{ flowId }})
    <!--<router-view class="ui applications__route"></router-view>-->
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';
</style>

<script>
// @flow
import ApplicationMenu from './../ApplicationMenu'
import { Application, Flow } from 'services'

export default {
  name: 'flow-item',
  components: { ApplicationMenu },

  props: ['appId', 'flowId'],

  data() {
    return {
      app: {},
      flow: {}
    }
  },

  methods: {
    readApp() {
      Application.readApp(this.appId).then(app => {
        this.app = app
        return app
      })
    },

    readFlow() {
      Flow.readFlow(this.flowId).then(flow => {
        this.flow = flow
        return flow
      })
    }
  },

  mounted() {
    this.readApp()
    this.readFlow()
  },

  watch: {
    // function is used to do dynamic binding of this
    flowId: function() {
      this.readFlow()
    }
  }
}
</script>
